export default __webpack_public_path__ + "resources/icons/d400-635f.png";